import React from 'react';
import PropTypes from 'prop-types';
import classSet from 'classnames';

// styles
import css from './spinner.sss';

export const Spinner = (props) => {
    const totalClasses = classSet(
        css.root,
        {
            [css.size16]: props.size === '16',
            [css.size20]: props.size === '20',
            [css.size30]: props.size === '30',
            [css.size40]: props.size === '40',
        },
    );

    return (
        <span className={totalClasses}>
            <span className={css.circle}>
                <span className={css.innerCircle} />
            </span>
        </span>
    );
};

Spinner.propTypes = {
    size: PropTypes.string,
};
